module.exports = __webpack_public_path__ + "assets/img/37_69_big.149ac2f5.jpg";